import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComments = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.43403 1.36675H4.66042C3.20413 1.36675 2.47599 1.36675 1.91977 1.65016C1.4305 1.89946 1.03271 2.29725 0.783411 2.78652C0.5 3.34275 0.5 4.07089 0.5 5.52717V10.0343C0.5 10.8403 0.5 11.2434 0.588602 11.574C0.82904 12.4714 1.52993 13.1723 2.42726 13.4127C2.75793 13.5013 3.16096 13.5013 3.96701 13.5013V15.5256C3.96701 15.9875 3.96701 16.2184 4.06169 16.337C4.14403 16.4401 4.26888 16.5001 4.40086 16.5C4.55262 16.4998 4.73294 16.3556 5.09358 16.0671L7.16119 14.413C7.58356 14.0751 7.79474 13.9061 8.02991 13.786C8.23855 13.6794 8.46064 13.6015 8.69014 13.5544C8.94883 13.5013 9.21928 13.5013 9.76018 13.5013H11.0744C12.5307 13.5013 13.2588 13.5013 13.815 13.2179C14.3043 12.9686 14.7021 12.5708 14.9514 12.0815C15.2348 11.5253 15.2348 10.7972 15.2348 9.34089V9.16754M15.34 1.2616C16.3554 2.27706 16.3554 3.92346 15.34 4.93892C14.3245 5.95439 12.6781 5.95439 11.6626 4.93892C10.6472 3.92346 10.6472 2.27706 11.6626 1.2616C12.6781 0.246134 14.3245 0.246134 15.34 1.2616Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgComments);
export default ForwardRef;
